export default "__VITE_ASSET__Pvcu43kk__"